// Custom Add to Cart with Popup Box
const CustomAddToCart = {
  currentVariant: null, // Store current variant from theme events
  isAdding: false,

  getProperties: function () {
    const form = document.querySelector(".product-single__form");
    if (!form) return {};

    const properties = {};
    const inputs = form.querySelectorAll("input, select, textarea");

    inputs.forEach((input) => {
      const name = input.name;
      if (name && name.includes("properties")) {
        const matches = name.match(/\[(.*?)\]/);
        if (matches) {
          const propertyName = matches[1];
          if (input.type === "checkbox") {
            if (input.checked) properties[propertyName] = input.value;
          } else if (input.type === "radio") {
            if (input.checked) properties[propertyName] = input.value;
          } else if (input.value) {
            properties[propertyName] = input.value;
          }
        }
      }
    });

    return properties;
  },

  getCurrentVariant: function () {
    // Shopify updates the URL reliably even when a custom variant listener loads late.
    const variantIdFromUrl = new URLSearchParams(window.location.search).get("variant");
    const variantJson = document.querySelector("[data-variant-json]");
    if (variantIdFromUrl && variantJson) {
      try {
        const variants = JSON.parse(variantJson.value || variantJson.textContent);
        const variantFromUrl = variants.find((variant) => String(variant.id) === variantIdFromUrl);
        if (variantFromUrl) return variantFromUrl;
      } catch (error) {
        // Fall through to the event/hidden-input fallback below.
      }
    }

    // Return stored variant from theme events, or try to get from hidden input as fallback
    if (this.currentVariant) {
      return this.currentVariant;
    }

    // Fallback: try to get variant ID from hidden input
    const variantIdInput = document.querySelector('input[name="variant-id"]');
    if (variantIdInput && variantIdInput.value) {
      return { id: variantIdInput.value };
    }

    return null;
  },

  updateVariantId: function (variant) {
    // Update hidden variant-id input
    const variantIdInput = document.querySelector('input[name="variant-id"]');
    if (variantIdInput && variant) {
      variantIdInput.value = variant.id;
    }

  },

  syncVariantFromInputs: function () {
    const variantJson = document.querySelector("[data-variant-json]");
    if (!variantJson) return;

    let variants;
    try {
      variants = JSON.parse(variantJson.value || variantJson.textContent);
    } catch (error) {
      return;
    }

    const selectedOptions = [];
    document.querySelectorAll("[data-variant-input]").forEach((input) => {
      if ((input.type === "radio" || input.type === "checkbox") && !input.checked) {
        return;
      }
      selectedOptions[Number(input.dataset.index.replace("option", "")) - 1] = input.value;
    });

    const variant = variants.find((candidate) =>
      selectedOptions.every((value, index) => value == null || candidate[`option${index + 1}`] === value),
    );

    if (variant) {
      this.currentVariant = variant;
      this.updateVariantId(variant);
    }
  },

  init: function () {
    // Listen for theme's variant change events
    document.addEventListener("variant:change", (e) => {
      if (e.detail && e.detail.variant) {
        this.currentVariant = e.detail.variant;
        this.updateVariantId(this.currentVariant);
      }
    });

    document.querySelectorAll("[data-variant-input]").forEach((input) => {
      input.addEventListener("change", this.syncVariantFromInputs.bind(this));
    });

    this.syncVariantFromInputs();

    // Set initial variant from hidden input if available
    const variantIdInput = document.querySelector('input[name="variant-id"]');
    if (variantIdInput && variantIdInput.value) return;
  },

  getQuantity: function () {
    const quantityInput =
      document.querySelector('input[name="quantity"]') ||
      document.querySelector(".quantity input") ||
      document.querySelector("[data-quantity-input]");
    return quantityInput ? parseInt(quantityInput.value) || 1 : 1;
  },

  addToCart: function () {
    const variant = this.getCurrentVariant();

    if (!variant) {
      // Try to get variant ID from hidden input as last resort
      const variantIdInput = document.querySelector('input[name="variant-id"]');
      if (variantIdInput && variantIdInput.value) {
        const fallbackVariant = { id: variantIdInput.value };
        this.proceedWithAddToCart(fallbackVariant);
        return;
      }

      return;
    }

    this.proceedWithAddToCart(variant);
  },

  proceedWithAddToCart: function (variant) {
    if (this.isAdding) return;

    const quantity = this.getQuantity();
    const properties = this.getProperties();

    const cartData = {
      id: variant.id,
      quantity: quantity,
      properties: properties,
    };

    // Show loading state
    const button = document.querySelector(".custom-atc-button");
    const originalText = button ? button.textContent : "";
    if (button) {
      this.isAdding = true;
      button.classList.add("btn--loading");
      button.setAttribute("aria-busy", "true");
      button.textContent = "Adding...";
      button.disabled = true;
    }

    // Add to cart
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cartData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 422) {
          throw data;
        }

        // Reset button
        if (button) {
          button.classList.remove("btn--loading");
          button.setAttribute("aria-busy", "false");
          button.textContent = originalText;
          button.disabled = false;
        }
        this.isAdding = false;

        // Get updated cart and show popup
        this.showPopupWithCartData(cartData, quantity);
      })
      .catch((error) => {
        // Reset button
        if (button) {
          button.textContent = "Error - Try Again";
          setTimeout(() => {
            button.classList.remove("btn--loading");
            button.setAttribute("aria-busy", "false");
            button.textContent = originalText;
            button.disabled = false;
            this.isAdding = false;
          }, 2000);
        } else {
          this.isAdding = false;
        }
      });
  },

  showPopupWithCartData: function (cartData, quantity) {
    // Get cart data
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // Update cart count
        const itemCountEl = document.querySelector(".cart__item-count");
        if (itemCountEl) {
          itemCountEl.innerText = cart.item_count;
        }

        // Get the added product (last item or find by variant ID)
        const product =
          cart.items.find((item) => item.variant_id == cartData.id) ||
          cart.items[cart.items.length - 1];

        if (product) {
          this.populatePopup(product, quantity);
        }

        // Show popup
        const popupBox = document.querySelector(".popup-box");
        if (popupBox) {
          popupBox.classList.add("active");

          setTimeout(function () {
            popupBox.classList.remove("active");
          }, 5000);
        }
      })
      .catch((error) => {
        // Show simple popup without cart data
        const popupBox = document.querySelector(".popup-box");
        if (popupBox) {
          popupBox.classList.add("active");
          setTimeout(() => popupBox.classList.remove("active"), 5000);
        }
      });
  },

  populatePopup: function (product, quantity) {
    // Update quantity
    const qtyElement = document.querySelector(
      ".popup-box .product--qty .value",
    );
    if (qtyElement) {
      qtyElement.textContent = quantity;
    }

    // Clear and populate product attributes
    const productLoop = document.querySelector(".popup-box .product--loop");
    if (productLoop) {
      productLoop.innerHTML = "";

      // Add product options
      if (product.options_with_values) {
        product.options_with_values.forEach((option) => {
          if (option.name !== "Size") {
            const attrDiv = document.createElement("div");
            attrDiv.className = "product--attr";
            attrDiv.innerHTML = `
                            <span class="label">${option.name}:</span>
                            <span class="value">${option.value}</span>
                        `;
            productLoop.appendChild(attrDiv);
          }
        });
      }

      // Add product properties
      if (product.properties) {
        Object.keys(product.properties).forEach((key) => {
          const value = product.properties[key];

          // Skip private properties and specific exclusions
          if (
            key.charAt(0) === "_" ||
            key === "MOQ100" ||
            key === "Surcharge"
          ) {
            return;
          }

          const attrDiv = document.createElement("div");
          attrDiv.className = "product--attr";
          attrDiv.innerHTML = `
                        <span class="label">${key}:</span>
                        <span class="value">${value}</span>
                    `;
          productLoop.appendChild(attrDiv);
        });
      }
    }
  },
};

// Initialize immediately when this deferred asset is loaded after DOMContentLoaded.
// Shopify previews can load this asset after the DOM-ready event has already fired;
// waiting only for DOMContentLoaded would then skip the variant:change listener.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    CustomAddToCart.init();
  });
} else {
  CustomAddToCart.init();
}

// Event listener for custom add to cart button
document.addEventListener("click", function (e) {
  if (
    e.target.matches(".custom-atc-button") ||
    e.target.closest(".custom-atc-button")
  ) {
    const trigger = e.target.closest(".custom-atc-button");
    if (trigger && trigger.closest(".product-single__form")) {
      return;
    }

    e.preventDefault();

    CustomAddToCart.addToCart();
  }
});
